import { render, staticRenderFns } from "./Credit.vue?vue&type=template&id=048f80ba"
var script = {}
import style0 from "./Credit.vue?vue&type=style&index=0&id=048f80ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports